{
  "DATA_ASSISTANT": {
    "TITLE": "Asystent danych",
    "NEW_CONVERSATION": "+ Nowa",
    "LOADING": "Ładowanie...",
    "LOADING_MESSAGES": "Ładowanie wiadomości...",
    "THINKING": "Myślenie...",
    "UNTITLED": "Rozmowa bez tytułu",
    "NO_CONVERSATIONS": "Brak rozmów. Kliknij \"+ Nowa\", aby rozpocząć.",
    "EMPTY_STATE": "Wybierz rozmowę lub utwórz nową, aby rozpocząć.",
    "SEND": "Wyślij",
    "PLACEHOLDER": "Czego mogę się dla Ciebie dowiedzieć?",
    "SHOW_SQL": "Pokaż SQL",
    "NO_ROWS": "Nie zwrócono żadnych wierszy.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Usuń rozmowę",
    "DELETE_CONFIRM_DESCRIPTION": "Czy na pewno chcesz usunąć tę rozmowę? Tej operacji nie można cofnąć.",
    "DELETE_CONFIRM_YES": "Usuń",
    "CHAT": "Czat",
    "REPORTS": "Raporty",
    "SAVE_TO_REPORT": "Zapisz do raportu",
    "NEW_REPORT": "Nowy raport",
    "REPORT_NAME": "Nazwa raportu",
    "NO_REPORTS": "Brak zapisanych raportów",
    "REPORTS_EMPTY_STATE": "Wybierz raport lub utwórz nowy.",
    "REPORT_SAVED": "Zapisano do raportu",
    "DELETE_REPORT_CONFIRM": "Usuń raport",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Czy na pewno chcesz usunąć ten raport? Wszystkie zapisane elementy zostaną usunięte.",
    "DELETE_ITEM_CONFIRM": "Usuń element",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Czy na pewno chcesz usunąć ten element z raportu?",
    "EXPORT_CSV": "Eksportuj CSV",
    "REFRESH": "Odśwież",
    "QUERY_RUNNING": "Wykonywanie zapytania...",
    "QUERY_FAILED": "Zapytanie nieudane",
    "AUTO_REFRESH": "Automatyczne odświeżanie",
    "AUTO_REFRESH_NONE": "Ręcznie",
    "AUTO_REFRESH_30S": "30 sekund",
    "AUTO_REFRESH_1M": "1 minuta",
    "AUTO_REFRESH_5M": "5 minut",
    "AUTO_REFRESH_10M": "10 minut",
    "EDIT_MESSAGE": "Edytuj wiadomość",
    "RENAME_REPORT": "Zmień nazwę raportu",
    "RENAME_ITEM": "Zmień nazwę elementu",
    "MOVE_UP": "Przenieś w górę",
    "MOVE_DOWN": "Przenieś w dół",
    "COLLABORATORS": {
      "BUTTON": "Współpracownicy",
      "TITLE": "Współpracownicy raportu",
      "DESCRIPTION": "Wybierz, którzy agenci i zespoły mogą wyświetlać ten raport.",
      "AGENTS": "Agenci",
      "TEAMS": "Zespoły",
      "SELECT_AGENTS": "Wybierz agentów",
      "SELECT_TEAMS": "Wybierz zespoły",
      "SAVE": "Zapisz",
      "SAVED": "Zaktualizowano współpracowników",
      "SAVE_FAILED": "Nie udało się zaktualizować współpracowników"
    }
  },
  "DATA_ASSISTANT_CHAT": "Czat",
  "DATA_ASSISTANT_REPORTS": "Raporty"
}
